import * as tslib_1 from "tslib";
import { DefaultUrlSerializer, Routes, UrlTree, } from '@angular/router';
import { UiPathComponent } from '@app/uipath.component';
import { FeatureFlagGuard, FolderParamGuard, LicenseGuard, ModalGuard, NoSessionGuard, PermissionGuard, TenantGuard, } from '@guards';
import { TENANT_ROUTES, } from './uipath-tenant-routing.module';
var LowerCaseUrlSerializer = /** @class */ (function (_super) {
    tslib_1.__extends(LowerCaseUrlSerializer, _super);
    function LowerCaseUrlSerializer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LowerCaseUrlSerializer.prototype.parse = function (url) {
        var queryStartIndex = url.indexOf('?');
        var queryStart = queryStartIndex === -1 ? url.length : queryStartIndex;
        var location = url.substring(0, queryStart).toLowerCase();
        var params = url.substring(queryStart, url.length);
        return _super.prototype.parse.call(this, "" + location + params);
    };
    return LowerCaseUrlSerializer;
}(DefaultUrlSerializer));
export { LowerCaseUrlSerializer };
var PARENT_ROUTES = [{
        path: 'account',
        runGuardsAndResolvers: 'always',
        loadChildren: './pages/auth/auth.module#AuthModule',
        canActivate: [NoSessionGuard],
    }, {
        path: 'host',
        runGuardsAndResolvers: 'always',
        canActivate: [PermissionGuard, TenantGuard],
        component: UiPathComponent,
        loadChildren: './pages/host/host.module#HostModule',
    }, {
        path: '',
        runGuardsAndResolvers: 'always',
        canActivate: [FolderParamGuard, FeatureFlagGuard, PermissionGuard, TenantGuard, LicenseGuard],
        canDeactivate: [ModalGuard],
        component: UiPathComponent,
        children: TENANT_ROUTES,
    }];
var UiPathRoutingModule = /** @class */ (function () {
    function UiPathRoutingModule() {
    }
    return UiPathRoutingModule;
}());
export { UiPathRoutingModule };
